import { useEffect } from "react";
import { Link } from "react-router";
import { styled } from "styled-components";

import { ChevronIcon } from "common/components";
import { linkStyles } from "common/styles";
import { useDispatch, useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { TopicSection } from "domains/discover/components/TopicSection";
import { getSiteLanguage } from "domains/language/selectors";
import { getCanFollowTopic } from "entities/permissions/selectors";
import { fetchFollowedTopics } from "entities/topics/actions";
import { createTopicsSelector, getFollowedTopicsIds, getFollowedTopicsIsPending } from "entities/topics/selectors";

const StyledLink = styled(Link)`
  ${linkStyles}
`;

const StyledArrow = styled(ChevronIcon)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.textBright};
  padding-left: 0.5rem;
`;

export const FollowingTopics = () => {
  const dispatch = useDispatch();
  const followingTopics = useMemoisedSelector(getFollowedTopicsIds, createTopicsSelector);
  const canFollowTopic = useSelector(getCanFollowTopic);
  const isPending = useSelector(getFollowedTopicsIsPending);
  const siteLanguage = useSelector(getSiteLanguage);
  const translate = useTranslate();

  useEffect(() => {
    if (canFollowTopic) {
      dispatch(fetchFollowedTopics({ offset: 0, limit: 8 }));
    }
  }, [canFollowTopic, dispatch, siteLanguage]);

  if (followingTopics.length === 0) {
    return null;
  }

  return (
    <TopicSection
      isPending={isPending}
      title={
        <StyledLink to="/followed">
          {translate("app.monitor.following_topics")}
          <StyledArrow />
        </StyledLink>
      }
      titleDataTestId="following-section-title"
      topicBack={{ term: "app.home" }}
      topics={followingTopics.slice(0, 8)}
    />
  );
};
